import types from './types';
import { getErrorMessage } from '../../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_CHEMICAL_PRODUCT_HISTORY_FAILURE:
      return {
        title: t('message.title.error.get.chemical.product.initial.data'),
        type: 'error'
      };
    case types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA_FAILURE:
      return {
        title: t('message.title.error.get.chemical.product.initial.data'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    default:
      return false;
  }
};
